/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Stop_Labels_Style_DisabledInputs */

const fr_settings_stop_labels_style_disabled = /** @type {(inputs: Settings_Stop_Labels_Style_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const en_settings_stop_labels_style_disabled = /** @type {(inputs: Settings_Stop_Labels_Style_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Settings_Stop_Labels_Style_DisabledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_stop_labels_style_disabled = /** @type {((inputs?: Settings_Stop_Labels_Style_DisabledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Stop_Labels_Style_DisabledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_stop_labels_style_disabled(inputs)
	return en_settings_stop_labels_style_disabled(inputs)
});